import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AUX from "../../hoc/AU-X/AU-X";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
import moment from "moment-jalaali";
import useAsync from "../../hooks/asyncRequests";
// import useWindowDimensions from "../../hooks/WindowDimensions";
import { ImageData, Stations, DataD, upperviewD } from "./HomeData";
import urmia from "../../assets/lake-custom.png";
// import urmiaMobile from "../../assets/overviewMobile.png";
import saddd from "../../assets/Home/saddd.png";
import sadd from "../../assets/Home/sadd.png";
import overViewClock from "../../assets/Home/overViewClock.png";
import sanat from "../../assets/Home/sanat.png";
import farming from "../../assets/Home/farming.png";
import shorb from "../../assets/Home/shorb.png";
import lake from "../../assets/Home/lake.png";
import mapLegend from "../../assets/Home/mapLegend2.png";
import legend from "../../assets/Home/legend2.png";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
import "./Home.scss";
import ScrollContainer from "react-indiana-drag-scroll";
import { Helmet } from "react-helmet";
import { logout } from "../../store";

import { setRTLTextPlugin } from "react-map-gl";
import useWindowDimensions from "../../hooks/WindowDimensions";

setRTLTextPlugin(
  // find out the latest version at https://www.npmjs.com/package/@mapbox/mapbox-gl-rtl-text
  "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
  null,
  // lazy: only load when the map first encounters Hebrew or Arabic text
  true
);

const sortedD = {
  ImageData: ImageData.sort((a, b) => a.serverID - b.serverID),
  Stations: Stations.sort((a, b) => a.serverID - b.serverID),
};

const Home = () => {
  const token = useSelector((state) => state.auth.Token);
  const { isLoadingAsync, finalData, clearAsync } = useAsync({
    Key: "matters not",
    reqData: {
      Lake: {
        url: "lake-overview/",
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
      Dam: {
        url: "dam-overview/",
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
      Watershed: {
        url: "watershed-overview/",
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
      Dams: {
        url: "dams/",
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
      Hydrometric: {
        url: "hydrometric-stations/",
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });
  const { width } = useWindowDimensions();
  const [infographD, setInfographD] = useState(sortedD);
  // const [overviewData, setOverviewData] = useState();
  const [loading, setLoading] = useState(true);
  const [UpperView, setUpperView] = useState();
  const dispatch = useDispatch();
  // const { width } = useWindowDimensions();
  const [lakeLabels] = useState([
    {
      label: "حجم فعلی (BCM)",
      value: "",
      date: "",
      name: "volume",
      type: "lake",
    },
    {
      label: "حجم روز مشابه در سال قبل (BCM)",
      value: "",
      date: "",
      name: "pre_volume",
      type: "lake",
    },
    {
      label: (
        <span>
          سطح فعلی (km<sup className="sup-text">2</sup>)
        </span>
      ),
      value: "",
      date: "",
      name: "area",
      type: "lake",
    },
    {
      label: (
        <span>
          سطح روز مشابه در سال قبل (km<sup className="sup-text">2</sup>)
        </span>
      ),
      value: "",
      date: "",
      name: "pre_area",
      type: "lake",
    },
    {
      label: "تراز فعلی (m)",
      value: "",
      date: "",
      name: "level",
      type: "lake",
    },
    {
      label: "تبخیر (mm)",
      value: "",
      date: "",
      name: "value",
      type: "evaporation",
    },
    {
      label: "کمترین تراز مشاهده شده (m)",
      value: "",
      date: "",
      name: "pre_level",
      type: "lake",
    },
    {
      label: "تراز اکولوژیک (m)",
      value: "1274.1",
      date: "",
      name: "",
      type: "lake",
    },
    {
      label: "حداقل تراز بستر (m)",
      value: "",
      date: "",
      name: "pre_level",
      type: "lake",
    },
    {
      label: (
        <span>
          مجموع ورودی به دریاچه از ابتدای سال آبی (m
          <sup className="sup-text">3</sup>/s)
        </span>
      ),
      value: "",
      date: "",
      name: "total_input",
      type: "input",
    },
    {
      label: (
        <span>
          میانگین بلند مدت 20 ساله مجموع ورودی به دریاچه از ابتدای سال آبی (m
          <sup className="sup-text">3</sup>/s)
        </span>
      ),
      value: "",
      date: "",
      name: "20_year_avg",
      type: "input",
    },
    {
      label: (
        <span>
          مجموع ورودی به دریاچه از ابتدای سال آبی تا روز مشابه در سال قبل (m
          <sup className="sup-text">3</sup>/s)
        </span>
      ),
      value: "",
      date: "",
      name: "pre_total_input",
      type: "input",
    },
  ]);
  const [volumeLabels] = useState([
    {
      label: "مجموع مصارف کشاورزی (MCM)",
      value: "",
      date: "",
      name: "cur_farmin_usage",
      type: "real",
    },
    {
      label: "برنامه مجموع مصارف کشاورزی (MCM)",
      value: "",
      date: "",
      name: "farming_usage",
      type: "program",
    },
    {
      label: "مجموع مصارف کشاورزی در سال گذشته (MCM)",
      value: "",
      date: "",
      name: "pre_farming_usage",
      type: "real",
    },
    {
      label: "مجموع مصارف کشاورزی در بدترین سال آبی از لحاظ بارش (MCM)",
      value: "",
      date: "",
      name: "farming_usage_worst_year",
      type: "real",
    },
    {
      label: "مجموع مصارف شرب (MCM)",
      value: "",
      date: "",
      name: "drinking_usage",
      type: "real",
    },
    {
      label: "برنامه مجموع مصارف شرب (MCM)",
      value: "",
      date: "",
      name: "drinking_usage",
      type: "program",
    },
    {
      label: "مجموع مصارف شرب در سال گذشته (MCM)",
      value: "",
      date: "",
      name: "pre_drinking_usage",
      type: "real",
    },
    {
      label: "مجموع مصارف شرب در بدترین سال آبی از لحاظ بارش (MCM)",
      value: "",
      date: "",
      name: "drinking_usage_worst_year",
      type: "real",
    },
    {
      label: "مجموع مصارف صنعت (MCM)",
      value: "",
      date: "",
      name: "cur_industrial_usage",
      type: "real",
    },
    {
      label: "برنامه مجموع مصارف صنعت (MCM)",
      value: "",
      date: "",
      name: "industrial_usage",
      type: "program",
    },
    {
      label: "مجموع مصارف صنعت در سال گذشته (MCM)",
      value: "",
      date: "",
      name: "pre_industrial_usage",
      type: "real",
    },
    {
      label: "مجموع مصارف صنعت در بدترین سال آبی از لحاظ بارش (MCM)",
      value: "",
      date: "",
      name: "industrial_usage_worst_year",
      type: "real",
    },
    {
      label: "رهاسازی دریاچه ارومیه (MCM)",
      value: "",
      date: "",
      name: "cur_other_usage",
      type: "real",
    },
    {
      label: "برنامه رهاسازی دریاچه ارومیه (MCM)",
      value: "",
      date: "",
      name: "other_usage",
      type: "program",
    },
    {
      label: "رهاسازی دریاچه ارومیه در سال گذشته (MCM)",
      value: "",
      date: "",
      name: "pre_other_usage",
      type: "real",
    },
    {
      label: "مجموع ورودی (MCM)",
      value: "",
      date: "",
      name: "cur_input",
      type: "real",
    },
    {
      label: "مجموع ورودی سال گذشته (MCM)",
      value: "",
      date: "",
      name: "pre_input",
      type: "real",
    },
    {
      label: (
        <span>
          حجم مخازن (m
          <sup className="sup-text">3</sup>/s)
        </span>
      ),
      value: "",
      date: "",
      name: "cur_volume",
      type: "real",
    },
    {
      label: "درصد پر بودن مخازن",
      value: "",
      date: "",
      name: "fullness_percentage",
      type: "real",
    },
    {
      label: (
        <span>
          حجم مخازن سال گذشته (m
          <sup className="sup-text">3</sup>/s)
        </span>
      ),
      value: "",
      date: "",
      name: "pre_volume",
      type: "real",
    },
  ]);
  const [aquiferLabels] = useState([
    {
      label: "تبخیر و تعرق (Dakadal-mm)",
      value: "",
      date: "",
      name: "value",
      type: "evaporation",
    },
    {
      label: "مجموع بارش از ابتدای سال آبی (mm)",
      value: "",
      date: "",
      name: "annually",
      type: "rainfall",
    },
    {
      label: "میانگین بلند مدت 52 ساله مجموع بارش تا روز مشابه (mm)",
      value: "",
      date: "",
      name: "total_mean",
      type: "rainfall",
    },
    {
      label: "مجموع بارش تا روز مشابه در سال آبی قبل (mm)",
      value: "",
      date: "",
      name: "last_year",
      type: "rainfall",
    },
    {
      label: "مجموع بارش تا روز مشابه در بدترین سال آبی (mm)",
      value: "",
      date: "",
      name: "worst_year",
      type: "rainfall",
    },
  ]);

  useEffect(() => {
    const fi = [
      { values: [], img: sanat, title: "صنعت" },
      { values: [], img: lake, title: "دریاچه" },
      { values: [], img: shorb, title: "شرب" },
      { values: [], img: farming, title: "کشاورزی" },
    ];
    const fetchOverView = async () => {
      await fetch("http://213.233.177.17:8022/lake-overview/", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            console.log("data is ", data);
            lakeLabels.forEach((item) => {
              if (data[item.type][item.name]) {
                item.value = data[item.type][item.name].toPrecision(4);
              }
              if (data[item.type].date) {
                item.date = moment(data[item.type].date).format(
                  "jYYYY/jMM/jDD"
                );
              }
            });
          }
        })
        .catch((err) => {
          setLoading(false);
        });
      await fetch("http://213.233.177.17:8022/dam-overview/", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            volumeLabels.forEach((item) => {
              if (data[item.type][item.name]) {
                item.value = data[item.type][item.name].toPrecision(4);
              }
              if (data[item.type].date) {
                item.date = moment(data[item.type].date).format(
                  "jYYYY/jMM/jDD"
                );
              }
            });
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      await fetch("http://213.233.177.17:8022/watershed-overview/", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            console.log("dam overview is ", data);
            aquiferLabels.forEach((item) => {
              if (data[item.type][item.name]) {
                item.value = data[item.type][item.name].toPrecision(4);
              }
              if (data[item.type].date) {
                item.date = moment(data[item.type].date).format(
                  "jYYYY/jMM/jDD"
                );
              }
            });
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    };
    fetchOverView();

    if (!finalData) {
      return;
    }

    if (finalData.Dam && finalData.Dam.error) {
      return;
    }

    const up = {};

    for (const the in upperviewD) {
      upperviewD[the].forEach((key) => {
        up[`${key}_${the}`] = finalData.Dam[the][key];
      });
    }
    console.log(up);

    for (const key in up) {
      const i = [-1, -1];
      if (key.indexOf("industrial") !== -1) {
        i[0] = 0;
      } else if (key.indexOf("farming") !== -1) {
        i[0] = 1;
      } else if (key.indexOf("drinking") !== -1) {
        i[0] = 2;
      } else if (key.indexOf("other") !== -1) {
        i[0] = 3;
      }

      if (key.indexOf("pre_real") !== -1) {
        i[1] = 2;
      } else if (key.indexOf("program") !== -1) {
        i[1] = 1;
      } else if (key.indexOf("worst_year_real") !== -1) {
        i[1] = 3;
      } else if (key.indexOf("real") !== -1) {
        i[1] = 0;
      }
      fi[i[0]].values[i[1]] = up[key] ? up[key].toFixed(3) : ".";
    }
    console.log(fi);
    setUpperView(fi);

    const { Dams, Hydrometric } = finalData;

    setInfographD((pre) => {
      const copy = { ...pre };
      const FD = { ImageData: [], Stations: [] };

      copy.ImageData.forEach((e, i) => {
        const the = Dams.find((element) => element.id === e.serverID);
        FD.ImageData[i] = { ...e, lastUpdate: the.volume };
      });
      copy.Stations.forEach((e, i) => {
        const the = Hydrometric.find((element) => element.id === e.serverID);
        FD.Stations[i] = { ...e, lastUpdate: the.discharge };
      });
      return FD;
    });

    const overViewD = { ...finalData, Dams: null, Hydrometric: null };
    const finalArrayObj = {};
    for (const data in overViewD) {
      if (overViewD[data] && !overViewD[data].error) {
        const array = [];

        for (const key in overViewD[data]) {
          for (const item in overViewD[data][key]) {
            DataD[data][key][item] &&
              array.push({
                title: DataD[data][key][item],
                value: overViewD[data][key][item]
                  ? overViewD[data][key][item].toFixed(2)
                  : null,
                date: overViewD[data][key]["date"]
                  ? moment(overViewD[data][key]["date"]).format("jYYYY/jMM/jDD")
                  : "",
                // : moment().format('jYYYY/jMM/jDD'),
              });
          }
        }

        DataD[data].leftOvers &&
          DataD[data].leftOvers.map((element) =>
            array.push({
              title: element.title,
              value: element.value,
              date: element.date
                ? element.date
                : moment().format("jYYYY/jMM/jDD"),
            })
          );

        finalArrayObj[data] = array;
      }
      console.log(finalArrayObj);
      // setOverviewData(finalArrayObj);
    }
  }, [
    finalData,
    clearAsync,
    setInfographD,
    dispatch,
    token,
    aquiferLabels,
    lakeLabels,
    volumeLabels,
  ]);

  const headerTable = () => {
    const indents = [];
    for (var i = 0; i < 3; i++) {
      indents.push(
        <div className="section">
          <div className="row">
            <div className="column1">
              <p>پارامتر</p>
            </div>
            <div className="column2">
              <p>مقدار</p>
            </div>
            <div className="column3">
              <p>تاریخ</p>
            </div>
          </div>
        </div>
      );
    }
    return indents;
  };

  const UpperViewUi = () => {
    const fi = [
      { values: [], img: sanat, title: "صنعت" },
      { values: [], img: lake, title: "دریاچه" },
      { values: [], img: shorb, title: "شرب" },
      { values: [], img: farming, title: "کشاورزی" },
    ];
    const data = UpperView ? UpperView : fi;
    return data.map((e) => (
      <div className="center" key={e.title}>
        <div>{e.values[0]}</div>
        <div>{e.values[1]}</div>
        <div>{e.values[2]}</div>
        <div>{e.values[3]}</div>
        <div>{e.title}</div>
        <img alt="overView" src={e.img} />
      </div>
    ));
  };

  return (
    <SpinnerHandler isLoading={loading || isLoadingAsync}>
      <Helmet>
        <title>خانه - سامانه پایش دینامیک دریاچه ارومیه</title>
      </Helmet>
      <Header />
      <div className="upperView">
        <UpperViewUi />
        <img alt={legend} src={legend} />
      </div>
      <div className="overView">
        <div className="center">
          <div className="clock-section">
            <NavLink
              to={{
                pathname: "/Chart/Lake",
                state: { name: "دریاچه", id: 1 },
              }}
            >
              <img alt="overViewClock" src={overViewClock} />
            </NavLink>
            <h4>دریاچه</h4>
          </div>
          <div className="clock-section">
            <NavLink
              to={{
                pathname: "/Chart/WareHouse",
                state: { name: "مخزن", id: 1 },
              }}
            >
              <img alt="overViewClock" src={overViewClock} />
            </NavLink>
            <h4>مخازن</h4>
          </div>
          <div className="clock-section">
            <NavLink
              to={{
                pathname: "/Chart/Watershed",
                state: { name: "حوضه آبریز", id: 1 },
              }}
            >
              <img alt="overViewClock" src={overViewClock} />
            </NavLink>
            <h4>حوضه آبریز</h4>
          </div>
        </div>
        <div className="header-table">{headerTable()}</div>
        <ScrollContainer hideScrollbars={false} className="table-box">
          <div className="sections-container">
            <div className="section">
              {width <= 450 && (
                <div className="title-table">
                  <h3 className="text">حوضه آبریز</h3>
                </div>
              )}
              {aquiferLabels.map((item, index) => (
                <div className="row">
                  <div className="column1">
                    <p>{item.label}</p>
                  </div>
                  <div className="column2">
                    <p>{item.value}</p>
                  </div>
                  <div className="column3">
                    <p>{item.date}</p>
                  </div>
                </div>
              ))}
            </div>
            {width <= 450 && (
              <div className="title-table">
                <h3 className="text">مخازن</h3>
              </div>
            )}

            <div className="section">
              {volumeLabels.map((item, index) => (
                <div className="row">
                  <div className="column1">
                    <p>{item.label}</p>
                  </div>
                  <div className="column2">
                    <p>{item.value}</p>
                  </div>
                  <div className="column3">
                    <p>{item.date}</p>
                  </div>
                </div>
              ))}
            </div>
            {width <= 450 && (
              <div className="title-table">
                <h3 className="text">دریاچه</h3>
              </div>
            )}
            <div className="section">
              {lakeLabels.map((item, index) => (
                <div className="row">
                  <div className="column1">
                    <p>{item.label}</p>
                  </div>
                  <div className="column2">
                    <p>{item.value}</p>
                  </div>
                  <div className="column3">
                    <p>{item.date}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </ScrollContainer>
        {/* <div>
          <div>
            {overviewData &&
              overviewData.Dam &&
              overviewData.Dam.map((e, i) => (
                <AUX key={e.title}>
                  {i !== 0 && (
                    <div className="line">
                      <div></div>
                    </div>
                  )}
                  <div>
                    <ul>
                      {overviewData.Lake && overviewData.Lake[i] && (
                        <AUX>
                          <li>{overviewData.Lake[i].title}</li>
                          <li>{overviewData.Lake[i].value}</li>
                          <li>
                            {overviewData.Lake[i].value &&
                              overviewData.Lake[i].date}
                          </li>
                        </AUX>
                      )}
                    </ul>
                    <ul>
                      <li>{e.title}</li>
                      <li>{e.value}</li>
                      <li>{e.value && e.date}</li>
                    </ul>
                    <ul>
                      {overviewData.Watershed && overviewData.Watershed[i] && (
                        <AUX>
                          <li>{overviewData.Watershed[i].title}</li>
                          <li>{overviewData.Watershed[i].value}</li>
                          <li>
                            {overviewData.Watershed[i].value &&
                              overviewData.Watershed[i].date}
                          </li>
                        </AUX>
                      )}
                    </ul>
                  </div>
                </AUX>
              ))}
          </div>
        </div> */}
      </div>
      <div className="mainImage">
        <div>
          <img alt="Urmia" src={urmia} />
          <div className="sads">
            {infographD.ImageData.map((e) => (
              <AUX key={e.id}>
                <img
                  style={{ ...e.position }}
                  className={`size${e.size}`}
                  alt={`${e.id} dam`}
                  src={saddd}
                />
                <img
                  style={{ ...e.position }}
                  className={`size${e.size}`}
                  alt={`${e.id} water amount`}
                  src={sadd}
                />
                <NavLink
                  to={{
                    pathname: `/DamChart`,
                    state: { id: e.serverID, name: e.id },
                  }}
                  style={{ ...e.linkPosition }}
                >
                  {e.id}
                  <span
                    style={{
                      position: "absolute",
                      top: "1px",
                      right: "4px",
                      color: "white",
                      fontSize: "8px",
                    }}
                  >
                    {e.lastUpdate && e.lastUpdate.value}
                  </span>
                </NavLink>
              </AUX>
            ))}
            {infographD.Stations.map((e) => (
              <NavLink
                key={e.id}
                to={{
                  pathname: `/Chart/Hydrometric`,
                  state: { name: e.id, id: e.serverID },
                }}
                style={{ paddingLeft: "12px", ...e.position }}
              >
                {e.id}
                <span
                  style={{
                    position: "absolute",
                    top: "1px",
                    right: "4px",
                    color: "white",
                    fontSize: "8px",
                  }}
                >
                  {e.lastUpdate && e.lastUpdate.value}
                </span>
              </NavLink>
            ))}
          </div>
        </div>
        <img src={mapLegend} alt="mapLegend" />
      </div>
      <Footer />
    </SpinnerHandler>
  );
};

export default Home;
